import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import { ErrorResponseType } from '../types';
import { MentorDashboardStats } from '../types/MentorDashboardStat';

const getMentorDashboardStatsCode = import.meta.env
  .VITE_GET_MENTOR_DASHBOARD_STATS;

export const getMentorDashboardStats = async (selectedYear: number) => {
  const ret: { data?: MentorDashboardStats; error: ErrorResponseType | null } =
    { error: null };

  try {
    const { data } = await axios.get(
      `${apiPaths.menteeReviewStats}/${selectedYear}/?code=${getMentorDashboardStatsCode}`
    );

    if (data) ret.data = data;
    else ret.error = errMsgNoData();

    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
